module.exports = __webpack_public_path__ + "app/assets/images/woman8-21fbcc771e42a97da3a44ce3932ba036.jpg";